<template>
  <div class="category mt-10 bg-white">
    <div class="category__top h-24 flex items-center border-b-2 border-solid">
      <div class="category__top__text ml-8 text-3xl">หมวดหมู่</div>
    </div>

    <div class="category__wrapper overflow-auto">
      <ul class="category__wrapper__list flex">
        <li v-for="(item, index) in list" :key="index" class="category__wrapper__item text-center">
          <a href="" class="
              category__wrapper__link
              flex flex-col
              items-center
              justify-center
            "
          >
            <div
              class="category__wrapper__link__img bg-contain bg-no-repeat"
              :style="url(item.url1)"
            ></div>
            <div class="category__wrapper__link__text flex-1 text-xl px-1">
              {{ item.text1 }}
            </div>
          </a>
          <a
            href=""
            class="
              category__wrapper__link
              flex flex-col
              items-center
              justify-center
            "
          >
            <div
              class="category__wrapper__link__img bg-contain bg-no-repeat"
              :style="url(item.url2)"
            ></div>
            <div class="category__wrapper__link__text flex-1 text-xl px-1">
              {{ item.text2 }}
            </div>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeCategory",
  setup() {
    const list = [
      {
        url1: "https://cf.shopee.vn/file/687f3967b7c2fe6a134a2c11894eea4b_tn",
        text1: "แฟชั่นผู้ชาย",
        url2: "https://cf.shopee.vn/file/75ea42f9eca124e9cb3cde744c060e4d_tn",
        text2: "แฟชั่นผู้หญิง",
      },
      {
        url1: "https://cf.shopee.vn/file/31234a27876fb89cd522d7e3db1ba5ca_tn",
        text1: "โทรศัพท์และอุปกรณ์เสริม",
        url2: "https://cf.shopee.vn/file/099edde1ab31df35bc255912bab54a5e_tn",
        text2: "แม่และเด็ก",
      },
      {
        url1: "https://cf.shopee.vn/file/978b9e4cb61c611aaaf58664fae133c5_tn",
        text1: "อุปกรณ์อิเล็กทรอนิกส์",
        url2: "https://cf.shopee.vn/file/24b194a695ea59d384768b7b471d563f_tn",
        text2: "เครื่องครัว",
      },
      {
        url1: "https://cf.shopee.vn/file/c3f3edfaa9f6dafc4825b77d8449999d_tn",
        text1: "คอมพิวเตอร์และแล็ปท็อป",
        url2: "https://cf.shopee.vn/file/c765998fda99b2be9eb6e348df29af28_tn",
        text2: "ความงาม",
      },
      {
        url1: "https://cf.shopee.vn/file/ec14dd4fc238e676e43be2a911414d4d_tn",
        text1: "กล้องและอุปกรณ์ถ่ายภาพ",
        url2: "https://cf.shopee.vn/file/bf87b50b463f646bb7fb8a1a606d9ed2_tn",
        text2: "สุขภาพ",
      },
      {
        url1: "https://cf.shopee.vn/file/86c294aae72ca1db5f541790f7796260_tn",
        text1: "นาฬิกา",
        url2: "https://cf.shopee.vn/file/48630b7c76a7b62bc070c9e227097847_tn",
        text2: "รองเท้าสตรี",
      },
      {
        url1: "https://cf.shopee.vn/file/74ca517e1fa74dc4d974e5d03c3139de_tn",
        text1: "รองเท้าผู้ชาย",
        url2: "https://cf.shopee.vn/file/fa6ada2555e8e51f369718bbc92ccc52_tn",
        text2: "กระเป๋าสตางค์",
      },
      {
        url1: "https://cf.shopee.vn/file/7abfbfee3c4844652b4a8245e473d857_tn",
        text1: "เครื่องใช้ไฟฟ้าในครัวเรือน",
        url2: "https://cf.shopee.vn/file/8e71245b9659ea72c1b4e737be5cf42e_tn",
        text2: "เครื่องประดับ",
      },
      {
        url1: "https://cf.shopee.vn/file/6cb7e633f8b63757463b676bd19a50e4_tn",
        text1: "กีฬาและการเดินทาง",
        url2: "https://cf.shopee.vn/file/c432168ee788f903f1ea024487f2c889_tn",
        text2: "อาหาร",
      },
      {
        url1: "https://cf.shopee.vn/file/3fb459e3449905545701b418e8220334_tn",
        text1: "รถยนต์",
        url2: "https://cf.shopee.vn/file/36013311815c55d303b0e6c62d6a8139_tn",
        text2: "หนังสือ",
      }
    ];

    return {
      list
    };
  },
  methods: {
    url: function (url) {
      return `background-image: url(${url});`;
    }
  },
  components: {
      
  },
};
</script>

<style scoped>
.category__wrapper__link {
  width: 12rem;
  height: 15rem;
  border: 1px solid #ccc;
}

.category__wrapper__link__img {
  width: 70%;
  height: 70%;
  margin-top: 10%;
}
</style>